import React, { useState, useEffect, useContext, useRef, forwardRef } from "react";
import $ from "jquery";
import ModifyZone from "./ModifyZone";
import WorkHours from "./WorkHours";
import SessionManager from "../../routes/SessionManager";
import SiteActivities from "../activity-thresholds/SiteActivities";
import bootbox from "bootbox";
// import PPESettings from './PPESettings';
import AdvanceWorkHours from "./AdvanceWorkHours";
import Holidays from "./Holidays";
import Toastr from "toastr";
import CommonUtils from "../../util/CommonUtils";
import { Context } from '../../views/app';

const supportedFileTypes = ['jpg', 'png', 'jpeg']

function Site(props, refs) {
  let appContex = useContext(Context);

  let SiteActivitiesRef = useRef(null);
  let ModifyZoneRef = useRef(null);
  let WorkHoursRef = useRef(null);
  let AdvancedWorkHoursRef = useRef(null);
  let deleteBtnRef = useRef(null);
  let sessionMgr = new SessionManager();
  let user = sessionMgr.readCookie("user");
  let site_changes = {
    work_hours: false,
    modify_zone: false,
    site_activities: false,
    view_streaming: false,
    security_settings: false,
    site_logo: false
  };

  const [talk_down_enabled, setTalkDownEnabled] = useState(null);
  const [extended_enabled, setExtendedEnabled] = useState(user.site_selected.site_config.work_hours.extended_enabled === undefined ? false : user.site_selected.site_config.work_hours.extended_enabled);
  const [view_streaming, setViewStreaming] = useState(user.site_selected.site_view_streaming === undefined ? true : user.site_selected.site_view_streaming);
  const [site_selected, setSiteSelected] = useState(user.site_selected);
  let site_original = JSON.parse(JSON.stringify(user.site_selected));

  const isModified = () => {
    return (
      site_changes.work_hours ||
      site_changes.modify_zone ||
      site_changes.site_activities ||
      site_changes.security_settings ||
      site_changes.view_streaming ||
      site_changes.site_logo
    );
  };

  const resetSiteChanges = () => {
    if (site_changes.site_activities) {
      SiteActivitiesRef.resetSiteSettings();
    }
    if (site_changes.work_hours) {
      WorkHoursRef.resetChanges();
      AdvancedWorkHoursRef.resetAdvancedWorkHours();
      resetToggleBtn();
    }
    if (site_changes.modify_zone) {
      ModifyZoneRef.resetChanges();
    }

    if (site_changes.security_settings)
      resetStrobe();

    if (site_changes.view_streaming) {
      resetViewStreaming();
    }
    if (site_changes.site_logo) {
      resetSiteLogo();
    }
  };

  const isWorkHoursObjectModified = () => {
    var sessionMgr = new SessionManager();
    let userPrev = sessionMgr.readCookie("user");
    if (!extended_enabled && !userPrev.site_selected.site_config.work_hours.work_schedule) {
      delete user.site_selected.site_config.work_hours.work_schedule
      delete user.site_selected.site_config.work_hours.extended_enabled
    }
    let isModified = JSON.stringify(user.site_selected.site_config.work_hours) !== JSON.stringify(userPrev.site_selected.site_config.work_hours)
    changeDetected("work_hours", isModified);
  }

  useEffect(() => {
    if (extended_enabled) {
      $("#redirect").show();
    };
    fetchTalkDownDevices();
  }, []);

  useEffect(() => {
    if (view_streaming !== (user.site_selected.site_view_streaming === undefined ? true : user.site_selected.site_view_streaming)) {
      site_changes.view_streaming = true;
    } else {
      site_changes.view_streaming = false;
    }
    changeDetected('view_streaming', isModified());
  }, [view_streaming]);

  useEffect(() => {
    var sessionMgr = new SessionManager();
    let userPrev = sessionMgr.readCookie("user");
    if (userPrev.site_selected.site_config.work_hours.extended_enabled) {
      user.site_selected.site_config.work_hours.extended_enabled = extended_enabled;
      isWorkHoursObjectModified();
    } else {
      if (extended_enabled === true) {
        user.site_selected.site_config.work_hours.extended_enabled = extended_enabled;
        isWorkHoursObjectModified();
      } else {
        changeDetected("work_hours", false);
      }
    }
    if (extended_enabled) {
      $("#redirect").show();
    } else {
      $("#redirect").hide();
    }
  }, [extended_enabled]);

  const fetchTalkDownDevices = () => {
    var data = {
      customer_id: user.customer_id,
      user_login: user.user_login,
      user_token: user.user_token,
      criteria: {
        from: 0,
        size: 1000,
        site_id: user.site_selected.site_id,
        advanced_filter: JSON.stringify([
          { attribute: 'strobe_talkdown', value: "true", operator: '=' }
        ]),
      }
    }

    $.ajax(
      {
        url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/comm_box/fetch',
        type: 'POST',
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(data)
      }
    ).then(
      (res) => {
        if (res.status && res.status.code === 200) {
          setTalkDownEnabled(res.data.total_records_found > 0);
        } else {
          setTalkDownEnabled(false);
        }
      },
      (res) => {
        setTalkDownEnabled(false);
      });
  }

  const resetSiteLogo = () => {
    document.getElementById('input-file-now').value = "";
    site_changes.site_logo = false;
    changeDetected('site_logo', isModified());
  };

  const resetViewStreaming = () => {
    let isViewStreaming = (user.site_selected.site_view_streaming === undefined ? true : user.site_selected.site_view_streaming);
    setViewStreaming(isViewStreaming);
    site_changes.view_streaming = false;
    changeDetected('view_streaming', isModified());
  };

  const handleStrobe = () => {
    $('.strobe-checkbox').toggleClass('fa fa-check-square far fa-square');

    let isStrobeDisabled = $('.strobe-checkbox').hasClass('fa-check-square');
    if (isStrobeDisabled !== (user.site_selected.site_disable_strobe !== undefined ? user.site_selected.site_disable_strobe : false)) {
      site_changes.security_settings = true;
    } else {
      site_changes.security_settings = false;
    }
    changeDetected('security', isModified());
  }

  const resetStrobe = () => {
    let isStrobeDisabled = (user.site_selected.site_disable_strobe !== undefined ? user.site_selected.site_disable_strobe : false)
    if (isStrobeDisabled) {
      $('.strobe-checkbox').removeClass('far fa-square').addClass('fa fa-check-square');
    } else {
      $('.strobe-checkbox').removeClass('fa fa-check-square').addClass('far fa-square');
    }
    site_changes.security_settings = false;
    changeDetected('security', isModified());
  }

  const handleReset = () => {
    bootbox.dialog({
      closeButton: false,
      message: "Are you sure you want to reset the changes ?",
      buttons: [
        {
          label: "No",
          className: "btn btn-sm btn-default w-50",
          callback: () => { },
        },
        {
          label: "Yes",
          className: "btn btn-sm btn-primary w-50",
          callback: () => {
            resetSiteChanges();
          },
        },
      ],
    });
  };

  const handleDelete = () => {
    SiteActivitiesRef.deleteSiteSettings();
  };

  const showOrHideDeleteButton = flag => {
    if (deleteBtnRef.className) {
      deleteBtnRef.className =
        "btn btn-sm btn-danger btn-border-1 mr-2 " + (flag ? "" : "hide");
    }
  };

  const handleSave = async () => {
    var saveBtn = document.getElementById("save-settings");
    saveBtn.disabled = true;
    if (site_changes.site_activities) {
      SiteActivitiesRef.saveSiteSettings();
    }
    if (site_changes.modify_zone) {
      // console.log(ModifyZoneRef);
      ModifyZoneRef.modifyZone();
    }

    let isStrobeDisabled = $('.strobe-checkbox').hasClass('fa-check-square');
    if (isStrobeDisabled !== (user.site_selected.site_disable_strobe !== undefined ? user.site_selected.site_disable_strobe : false)) {
      updateSiteObject("strobe", isStrobeDisabled);
    }

    let isViewStreaming = (user.site_selected.site_view_streaming === undefined ? true : user.site_selected.site_view_streaming);
    if (isViewStreaming !== view_streaming) {
      updateSiteObject("view_streaming", view_streaming);
    }

    let site_logo = site_selected.image
    if (site_logo) {
      let data = {
        form_input: {
          image: site_logo,
          site_id: user.site_selected.site_id,
          customer_id: user.customer_id
        }
      };

      let site_logo_info = await saveSiteLogo(data.form_input);
      updateSiteObject("site_logo", site_logo_info);
    }

    if (site_changes.work_hours || site_changes.AdvWorkHours) {
      updateSiteConfig();
    }
  };

  const updateSiteObject = (type, value) => {
    let data = {
      user_login: user.user_login,
      user_token: user.user_token,
      user_type: 'user',
      form_input: {
        customer_id: user.customer_id,
        site_id: user.site_selected.site_id
      }
    };
    let updateParam = type === "strobe" ? 'site_disable_strobe' : (type === "site_logo" ? "site_logo" : 'site_view_streaming');
    data.form_input[updateParam] = value;

    $.ajax(
      {
        url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-table-operations/site/modify',
        type: 'POST',
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(data)
      }
    ).then(
      (res) => {
        if (res.status && res.status.code !== 200) {
          Toastr.error('An error occured ...please try again.', 'Error');
          $("#spinner").toggleClass("d-none");
          return;
        } else {
          if (type === "strobe") {
            Toastr.success('Security Devices configuration modified successfully!', 'Success');
          } else if (type === "site_logo") {
            Toastr.success('Site Logo configuration modified successfully!', 'Success');
          } else {
            Toastr.success('View Streaming configuration modified successfully!', 'Success');
          }
          var sessionMgr = new SessionManager();
          let userObj = sessionMgr.readCookie('user');
          userObj.site_selected[updateParam] = value;
          for (let s of userObj.site_locations) {
            if (s.site_id === user.site_selected.site_id) {
              s[updateParam] = value;
            }
          }
          sessionMgr.storeCookie('user', userObj);
          if (type === "strobe") {
            site_changes.security_settings = false;
            changeDetected('security', false);
          } else if (type === "site_logo") {
            document.getElementById('input-file-now').value = "";
            site_changes.site_logo = false;
            changeDetected('site_logo', false);
          } else {
            site_changes.view_streaming = false;
            changeDetected('view_streaming', false);
          }
        }
      },
      (res) => {
        Toastr.error('An error occured ...please try again.', 'Error');
      });
  }

  const resetToggleBtn = () => {
    var sessionMgr = new SessionManager();
    let userPrev = sessionMgr.readCookie("user");
    if (userPrev.site_selected.site_config.work_hours) {
      let extendedenabled = userPrev.site_selected.site_config.work_hours.extended_enabled;
      if (extendedenabled) {
        $("#redirect").show();
      } else {
        $("#redirect").hide();
      }
      setExtendedEnabled(extendedenabled ? extendedenabled : false);
      user.site_selected.site_config.work_hours.extended_enabled = extended_enabled;
      isWorkHoursObjectModified();
      changeDetected("work_hours", false);
    }
  }

  const changeDetected = (module, isModiy) => {
    site_changes[module] = isModiy;
    // console.log('module, isModiy', [module, isModiy]);

    if (isModified()) {
      $(".reset-site-changes").attr("disabled", false);
      $(".reset-site-changes").off("click").on("click", handleReset);
      $(".save-site-changes").attr("disabled", false);
      $(".save-site-changes").off("click").on("click", handleSave);
    } else {
      $(".reset-site-changes").attr("disabled", true);
      $(".save-site-changes").attr("disabled", true);
    }
  };

  const handleFileUpload = (site, target) => {

    var fileNamArray = target.files[0].name.split('.')
    var fileExtension = fileNamArray[fileNamArray.length - 1]

    if (supportedFileTypes.indexOf(fileExtension.toLowerCase()) === -1) {
      bootbox.alert("Supported file types are : JPG, PNG, JPEG", function (isYes) {
        document.getElementById("input-file-now").value = "";
      })
      changeDetected("site_logo", false);
      return
    }
    let imagePromise = CommonUtils.base64(target.files[0]).then(base64Data => {
      let file_name = target.files[0].name;
      let content_type = target.files[0].type;
      let image = { base64_file: base64Data, file_name, content_type };
      site["image"] = image;
    });

    imagePromise.then(() => {
      setSiteSelected(site);
      updateModifyStatus(site);
    });
  }

  const updateModifyStatus = (site) => {
    setSiteSelected(site);
    for (var k in site_selected) {
      if (site_original[k] !== site_selected[k]) {
        changeDetected("site_logo", true);
        break;
      }
    }
  }

  const saveSiteLogo = (modifiedAtts) => {
    return new Promise(async (resolve, reject) => {
      if (!modifiedAtts.image)
        resolve(null);

      let data = {
        user_login: user.user_login,
        user_token: user.user_token,
        ...modifiedAtts.image,
        Key: `cusr_${modifiedAtts.customer_id}/site_${modifiedAtts.site_id}/${modifiedAtts.image.file_name}`,
        customer_id: modifiedAtts.customer_id,
        site_id: user.site_selected.site_id
      }
      $.ajax(
        {
          url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-s3-operations/uploadLogo',
          type: 'POST',
          contentType: 'application/json; charset=utf-8',
          dataType: 'json',
          data: JSON.stringify(data)
        }
      ).then(
        res => {
          resolve(res.data.img);
        }
      );
    });
  }

  const updateSiteConfig = () => {
    if (!user.site_selected.site_config.work_hours.work_schedule && extended_enabled) {
      Toastr.error("Advanced work hours schedule can't be empty");
      return;
    }

    var test = false;
    if (user.site_selected.site_config.work_hours.work_schedule) {
      for (var key of Object.keys(user.site_selected.site_config.work_hours.work_schedule)) {
        if (user.site_selected.site_config.work_hours.work_schedule[key].find(val => val === 1)) {
          test = true;
        }
      }
      if (Object.keys(user.site_selected.site_config.work_hours.work_schedule).length === 0 || test === false) {
        Toastr.error("Advanced work hours schedule can't be empty");
        return;
      }
    };

    let data = {
      form_input: {
        customer_id: user.site_selected.customer_id,
        site_id: user.site_selected.site_id,
        site_config: JSON.stringify(user.site_selected.site_config),
      },
      customer_id: user.customer_id,
      site_id: user.site_selected.site_id,
      user_login: user.user_login,
      user_token: user.user_token,
    };

    // setState({ loading: true });
    $.ajax({
      url: "https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/site-config/update",
      type: "POST",
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      data: JSON.stringify(data),
    }).then(
      (res) => {

        if ((res.status && res.status.code !== 200) || (res.data && !(res.data.site_config || res.data.Attributes.site_config))) {
          Toastr.error("An error occured ...please try again.", "Error");
          $("#spinner").toggleClass("d-none");
          return;
        }
        Toastr.success("Site Configuration modified successfully", "Status");
        $("#spinner").toggleClass("d-none");
        let site_config = res.data.site_config || res.data.Attributes.site_config;
        let userObj = { ...user };
        userObj.site_selected.site_config = site_config;
        if (userObj.site_locations) {
          for (let site of userObj.site_locations) {
            if (site.site_id === userObj.site_selected.site_id) {
              site.site_config = site_config;
            }
          }
        }
        appContex.updateUser(userObj);
        isWorkHoursObjectModified('work_hours', false);
        $.event.trigger("work_hours_updated");
        $.event.trigger("refresh_notifications");
      },
      (err) => {
        Toastr.error("An error occured ...please try again.", "Error");
        $("#spinner").toggleClass("d-none");
      }
    );
  };

  React.useImperativeHandle(refs, () => ({
    isModified,
    handleSave
  }));

  return (
    <React.Fragment>
      <span className='pull-right'>
        <button className='btn btn-sm btn-light btn-border-1 mr-2 reset-site-changes' disabled> Cancel </button>
        <button ref={x => (deleteBtnRef = x)} className='hide' onClick={handleDelete}> Delete </button>
        <button id="save-settings" className='btn btn-sm btn-primary btn-border-1 save-site-changes' disabled> Save </button>
      </span>
      <br />
      <span className='bg-section'>Site Settings</span>
      <div className='border-section'>
        <div className='row'>
          <div className='col-md-6'>
            <div className='card border border-0 bg-light'>
              <div className='card-header p-0'>
                <div className='card-title pl-2 mb-0 bg-light p-1 text-capitalize text-bold'>
                  Standard Work Hours
                  <span className="pull-right">Advanced Work Hours <i className={"fa fa-lg text-success cursor-pointer " + (extended_enabled === true ? "fa-toggle-on" : "fa-toggle-off")} onClick={() => setExtendedEnabled(!extended_enabled)}></i></span>
                </div>
              </div>
              <div id={"content-work-hours"} aria-labelledby='headingOne'>
                <div className='card-body bg-white border-light'>
                  <WorkHours ref={x => (WorkHoursRef = x)} key={extended_enabled} site_component={{ user, isWorkHoursObjectModified }} extended_enabled={extended_enabled} />
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-6'>
            <div className='card border border-0 bg-light'>
              <div className='card-header p-0'>
                <div className='card-title pl-2 mb-0 bg-light p-1 text-capitalize text-bold'>
                  Rename Zones
                </div>
              </div>
              <div id={"content-windspeed"} aria-labelledby='headingOne'>
                <div className='card-body bg-white border-light'>
                  <ModifyZone ref={x => (ModifyZoneRef = x)} site_component={changeDetected} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='row pt-2' id='redirect'>
          <div className='col-md-12'>
            <div className='card border border-0 bg-light'>
              <div className='card-header p-0'>
                <div className='card-title pl-2 mb-0 bg-light p-1 text-capitalize text-bold'>
                  Advanced Work Hours
                </div>
              </div>
              <div aria-labelledby='headingOne'>
                <div className='card-body bg-white border-light'>
                  <AdvanceWorkHours ref={x => (AdvancedWorkHoursRef = x)} key={extended_enabled} site_component={{ user, isWorkHoursObjectModified }} extended_enabled={extended_enabled} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='row pt-2'>
          <div className='col-md-6'>
            <div className='card border border-0 bg-light'>
              <div className='card-header p-0'>
                <div className='card-title pl-2 mb-0 bg-light p-1 text-capitalize text-bold'>
                  Holidays
                </div>
              </div>
              <div aria-labelledby='headingOne'>
                <div className='card-body bg-white border-light'>
                  <Holidays />
                </div>
              </div>
            </div>
          </div>
          {CommonUtils.hasPermission('SITESUPT-UI-SITE-LOGO') &&
            <div className='col-md-6'>
              <div className='card border border-0 bg-light'>
                <div className='card-header p-0'>
                  <div className='card-title pl-2 mb-0 bg-light p-1 text-capitalize text-bold'>
                    Site Logo to display in Time Lapse video
                  </div>
                </div>
                <div aria-labelledby='headingOne'>
                  <div className="card-body bg-white border-light">
                    <label className="mt-2"> Choose Logo :
                      <input className="file-upload p-1 ml-3 bg-light border-rounded" type="file" id="input-file-now" onChange={(event) => handleFileUpload(site_selected, event.target)} accept=".jpg,.png,.jpeg" />
                    </label>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        <div className="row pt-2">
          {/* <div className="col-md-6">
              <div className='card border border-0 bg-light'>
                <div className='card-header p-0'>
                  <div className='card-title pl-2 mb-0 bg-light p-1 text-capitalize text-bold'>
                    PPE Settings
                  </div>
                </div>
                <div aria-labelledby='headingOne'>
                  <div className='card-body bg-white border-light'>
                    <PPESettings ref={x => PPEAwarenessRef = x} site_component={this} />
                  </div>
                </div>
              </div>
            </div> */}
          {CommonUtils.hasPermission('SITESUPT-UI-VIEW-STREAMING-TOGGLE') &&
            <div className='col-md-6'>
              <div className='card border border-0 bg-light'>
                <div className='card-header p-0'>
                  <div className='card-title pl-2 mb-0 bg-light p-1 text-capitalize text-bold'>
                    Streaming
                  </div>
                </div>
                <div aria-labelledby='headingOne'>
                  <div className='card-body bg-white border-light'>
                    View Streaming :<i onClick={() => setViewStreaming(!view_streaming)} className={view_streaming ? "fa fa-lg ml-3 fa-toggle-on text-success" : "fa fa-lg ml-3 fa-toggle-off text-gray"}></i>
                  </div>
                </div>
              </div>
            </div>}
          {CommonUtils.hasPermission('SITESUPT-UI-STROBE-MODIFY') && talk_down_enabled &&
            <div className='col-md-6'>
              <div className='card border border-0 bg-light'>
                <div className='card-header p-0'>
                  <div className='card-title pl-2 mb-0 bg-light p-1 text-capitalize text-bold'>
                    Security Devices
                  </div>
                </div>
                <div aria-labelledby='headingOne'>
                  <div className='card-body bg-white border-light'>
                    Disable Strobe : <i onClick={() => handleStrobe()} className={"strobe-checkbox ml-3 fa-lg " + (user.site_selected.site_disable_strobe === true ? "fa fa-check-square" : "far fa-square") + " fa-checkbox text-primary"}></i>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>

      </div>
      <br></br>
      <span className='bg-section'>Local Weather Alerts</span>

      <div className='border-section'>
        <SiteActivities site_component={{ changeDetected, showOrHideDeleteButton }} ref={x => (SiteActivitiesRef = x)} />
      </div>
    </React.Fragment>
  );

}
export default forwardRef(Site);
